// api/services/bookings.ts
import { fetchCustomerResource, handleRequest } from '@/api';
import type { BookingResponse, CreateBookingRequest, TerritorialContextResponse, UpdateBookingRequest } from '@/types';

interface CustomerRef {
    id: number;
}

interface BookingOperationResponse {
    message: string;
    booking_id: number;
    countries_processed: number;
}

export const getBookingsForCustomer = (customer: CustomerRef, signal?: AbortSignal): Promise<BookingResponse[]> =>
    fetchCustomerResource<BookingResponse[]>('bookings', customer.id, signal);

export const getTerritorialContext = (
    customer: CustomerRef,
    signal?: AbortSignal
): Promise<TerritorialContextResponse> =>
    fetchCustomerResource<TerritorialContextResponse>('bookings/territorial-context', customer.id, signal);

export const saveNewBooking = (payload: CreateBookingRequest): Promise<BookingOperationResponse> =>
    handleRequest<BookingOperationResponse>('post', `/bookings/`, payload, 'Booking saved successfully!');

export const updateBooking = (payload: UpdateBookingRequest): Promise<BookingOperationResponse> =>
    handleRequest<BookingOperationResponse>('put', `/bookings/${payload.id}`, payload, 'Booking updated.');

export const checkBookingArchive = (bookingId: number) =>
    handleRequest<{ can_archive: boolean; reason?: string; details?: Record<string, unknown> }>(
        'get',
        `/bookings/${bookingId}/archive-check`
    );

export const archiveBooking = (bookingId: number) =>
    handleRequest<BookingOperationResponse>('post', `/bookings/${bookingId}/archive`, {}, 'Booking archived.');
